module.exports = __webpack_public_path__ + "assets/img/warrior-name-0c4bc8ae.png";